/* istanbul ignore file */
import React from 'react';
import { CRB, SUTTON } from '@upgrade/ui-utils/constants/pcl/issuing-bank';
import { useTheme } from 'styled-components';
import formatCardName from '@upgrade/ui-utils/formatters/pcl/card-name';
import Link from '../../Link';
const ISSUING_BANK_LABEL = {
  [CRB]: 'Cross River Bank, Member FDIC',
  [SUTTON]: 'Sutton Bank, Member FDIC'
};
export const BankPartnersLink = ({
  publicSiteUrl
}) => /*#__PURE__*/React.createElement(Link, {
  href: `${publicSiteUrl}/bank-partners/`,
  openInNewWindow: true
}, "bank partners");
export const BankPartners = ({
  withAutoRefinance,
  publicSiteUrl = ''
}) => {
  const theme = useTheme();
  const text = withAutoRefinance ? theme.footerBankNoticePersonalLoanWithAutoRefinanceText : theme.footerBankNoticePersonalLoanText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text, /*#__PURE__*/React.createElement(BankPartnersLink, {
    publicSiteUrl: publicSiteUrl
  }), ".");
};
export const Cards = ({
  rewardProgramCode,
  programDefinitionCode,
  cardIssuingBanks = [CRB]
}) => {
  const cardName = formatCardName({
    code: programDefinitionCode || rewardProgramCode
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, cardIssuingBanks.length > 1 ? `All ${cardName}s are` : `The ${cardName} is`, " issued by", ' ', cardIssuingBanks.map(cardIssuingBank => ISSUING_BANK_LABEL[cardIssuingBank]).join(', or '), ", pursuant to a license from Visa U.S.A. Inc.");
};
export const DebitCards = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Upgrade Visa\xAE Debit Cards are issued by Cross River Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc.");

//
export const PersonalCreditLine = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Personal Credit Lines are issued by Cross River Bank, Member FDIC. ");
export const StateLicensesAndDBAs = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Upgrade, Inc. (NMLS #1548935) holds the following", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: "https://upgrade.zendesk.com/hc/en-us/articles/4404416360731-Overview-State-Licenses-and-Consumer-Information"
}, "state licenses"), ' ', "and does business under the following", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: "https://www.upgrade.com/dba/"
}, "DBAs"), ".");
export const StateLicensesFlexPay = ({
  publicSiteUrl = ''
}) => /*#__PURE__*/React.createElement(React.Fragment, null, "Uplift, Inc., (NMLS #1897458) holds the following", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: `${publicSiteUrl}/flex-pay/licenses/`
}, "state licenses"), ".");
export const FinancialInstitution = ({
  href = 'https://upgrade.zendesk.com/hc/en-us/articles/115005202407--Is-Upgrade-a-bank-'
}) => /*#__PURE__*/React.createElement(React.Fragment, null, "Upgrade is a", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: href
}, "financial technology company, not a bank"), ".");
export const CheckingSavings = ({
  withDeposit = false
}) => /*#__PURE__*/React.createElement(React.Fragment, null, withDeposit ? 'Checking and savings accounts' : 'Rewards Checking services', " provided by Cross River Bank, Member FDIC.");
export const HomeImprovement = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Home Improvement Loans are made by Cross River Bank, Member FDIC, Equal Housing Lender.");
export const FlexPay = ({
  publicSiteUrl = ''
}) => /*#__PURE__*/React.createElement(React.Fragment, null, "Loans made through Flex Pay (formerly known as Uplift) by Upgrade are provided by these", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: `${publicSiteUrl}/flex-pay/lenders/`
}, "lending partners"), ".");
//# sourceMappingURL=content.js.map